import styled from '@emotion/styled';
import { IconButton } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete';
import { ClassAttributes, createElement, MouseEventHandler } from 'react';

import { ProjectForAllOfOrganizationFragment } from '../../../../generated/graphql';
import theme from '../../../../theme';
import { SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';

interface Props {
  project: ProjectForAllOfOrganizationFragment;
  onClickDeleteButton: MouseEventHandler<HTMLElement>;
  className?: string;
}

const Actions = ({ project, onClickDeleteButton, className }: ClassAttributes<HTMLElement> & Props) => {
  const deleteButton =
    project.state === 'draft' ? (
      <ActionButton onClick={onClickDeleteButton}>
        <DeleteIcon color="secondary" />
      </ActionButton>
    ) : null;

  return <Root className={className}>{deleteButton}</Root>;
};

const Root = styled('div')(
  flexibleLayoutContainer({
    direction: 'row',
    wrap: 'nowrap',
    justifyItems: 'flex-start',
    alignItems: 'flex-end',
  }),
);

export const ActionButton = styled(IconButton)({
  marginRight: SPACING_UNIT,
  ':last-child': {
    marginRight: 0,
  },
});

const DeleteIcon = styled(Delete)({
  color: theme.palette.grey['500'],
});

export default Actions;
